import * as React from "react";
const SvgFiRrFileEps = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="#062147" clipPath="url(#fi-rr-file-eps_svg__a)">
      <path d="M6.962 5.818a.625.625 0 0 0 0-1.25h-2.2a.625.625 0 0 0-.625.625v5.214c0 .345.28.625.625.625h2.2a.625.625 0 1 0 0-1.25H5.39V8.425H6.8a.625.625 0 0 0 0-1.25H5.39V5.818zM8.851 5.169v5.262a.625.625 0 0 0 1.25 0V8.768h.839a2.11 2.11 0 0 0 0-4.22l-.001-.004H9.475a.63.63 0 0 0-.473.203.62.62 0 0 0-.151.422m2.088 2.345h-.832V5.79h.837a.86.86 0 1 1 0 1.72z" />
      <path d="M19 0H5a5.006 5.006 0 0 0-5 5v14a5.006 5.006 0 0 0 5 5h11.343a4.97 4.97 0 0 0 3.536-1.464l2.656-2.658A4.97 4.97 0 0 0 24 16.343V5a5.006 5.006 0 0 0-5-5M2 19V5a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10h-4a3 3 0 0 0-3 3v4H5a3 3 0 0 1-3-3m16.465 2.122c-.402.401-.91.679-1.465.8V18a1 1 0 0 1 1-1h3.925a3 3 0 0 1-.8 1.464z" />
      <path d="M16.857 7.255c-.273-.093-.556-.144-.835-.217a1.25 1.25 0 0 1-.594-.3.59.59 0 0 1-.152-.618.6.6 0 0 1 .49-.328c.207-.013.414.017.608.089q.419.13.819.309c.295.129.64.206.879-.074a.61.61 0 0 0 .032-.737 1.1 1.1 0 0 0-.407-.355 3.18 3.18 0 0 0-2.426-.331c-.434.137-.8.431-1.026.826a1.7 1.7 0 0 0-.207.605c-.056.382.027.773.234 1.1.233.341.57.599.96.735.41.168.818.33 1.233.483a1.3 1.3 0 0 1 .482.276.56.56 0 0 1 .15.579.72.72 0 0 1-.457.408c-.312.117-.654.13-.974.035a2.7 2.7 0 0 1-.848-.5c-.026-.021-.111-.085-.127-.1a.6.6 0 0 0-.76.05.625.625 0 0 0-.043.883c.596.634 1.43.991 2.3.986a2.14 2.14 0 0 0 2.178-1.66 1.77 1.77 0 0 0-.6-1.623 2.7 2.7 0 0 0-.91-.521" />
    </g>
    <defs>
      <clipPath id="fi-rr-file-eps_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFileEps;
